import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { DemoPage } from './App';
import reportWebVitals from './reportWebVitals';

const isDemo = window.location.pathname === '/demo';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isDemo ? <DemoPage /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
